export default {
	data(){
		return {		
			tableGBoptions: { 
				options: {editar: 'Editar Nota', eliminar: 'Eliminar Nota'},
			},

			tableGBSearch: ['datos_afiliado/name','datos_afiliado/documento'],
			
			tableGBItems: [
				{
					thead: { th: 'Documento' },
					tbody: { td: ['list_documento/name','datos_afiliado/documento'],}
				},
				{
					thead: { th: 'Nombres', sort: null, sortTable: 'datos_afiliado/name'},
					tbody: { td: ['datos_afiliado/name'],}
				},
				{
					thead: { th: 'Teléfonos'},
					tbody: { td: ['datos_afiliado/telefonos'],}
				},
				{
					thead: { th: 'Razón Social', sort: null, sortTable: 'datos_razon/name'},
					tbody: { td: ['datos_razon/name'],}
				},
				{
					thead: { th: 'Nota', },
					tbody: { td: ['notas_pendientes/nota'],}
				},
				{
					thead: { th: 'Fecha creación', },
					tbody: { td: ['notas_pendientes/updated_at'],}
				},
			],	
		}
	},
}